import React from "react";
import { CreateOrganisation } from "../components/organisation/CreateOrganisation";
import { OnboardingProvider } from "../components/organisation/onboarding/contexts/onboarding.context";

export const CreateOrganisationPage: React.FC = () => (
    <OnboardingProvider>
        <CreateOrganisation />
    </OnboardingProvider>
);
